import script from "./ConcessionaireHeader.vue?vue&type=script&setup=true&lang=js"
export * from "./ConcessionaireHeader.vue?vue&type=script&setup=true&lang=js"

import "./ConcessionaireHeader.vue?vue&type=style&index=0&id=05b577f6&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-05b577f6"]])

export default __exports__